module.exports = __webpack_public_path__ + "static/img/logo.f8be7339.svg";